/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { DefaultClusterLimits, DefaultLanguage } from 'shared';

import { SystemConfigurationFormValues } from './SystemConfigurationPage.types';

export enum EmailType {
  SMTP = 'SMTP',
  GMAIL = 'Gmail',
}

export const getInitialValues = (data: Partial<SystemConfigurationFormValues> = {}) => {
  return { ...initialValues, ...data };
};

export const initialValues: SystemConfigurationFormValues = {
  useSmtp: true,
  type: EmailType.SMTP,
  smtpHost: '',
  smtpPort: '',
  smtpSecure: false,
  smtpUser: '',
  smtpPass: '',
  enquiryEmails: '',
  enquiryEmailLanguage: DefaultLanguage,
  allowServiceCreation: true,
  showCost: true,
  showInstanceCost: true,
  showSupportCost: true,
  minCpuLimit: null,
  maxCpuLimit: null,
  minMemoryLimit: null,
  maxMemoryLimit: null,
  minStorageLimit: null,
  maxStorageLimit: null,
  minReplicasLimit: DefaultClusterLimits.Replicas.Min,
  maxReplicasLimit: DefaultClusterLimits.Replicas.Max,
  currency: 'EUR',
  cpuPricePerMonth: 0,
  memoryPricePerMonth: 0,
  storagePricePerMonth: 0,
  cpuRequestToLimitMultiplier: 1,
  smtpFromEmail: null,
  emailAddress: null,
  emailToken: null,
  imprint: '',
};

export const systemConfigValidationSchema = Yup.object({
  allowServiceCreation: Yup.boolean(),
  showInstanceCost: Yup.boolean(),
  showSupportCost: Yup.boolean(),
  minCpuLimit: Yup.number().min(DefaultClusterLimits.Cpu.Min, 'more_than_or_equal'),
  maxCpuLimit: Yup.number().when('minCpuLimit', function (minCpuLimit, schema) {
    if (minCpuLimit) {
      return schema.min(Number(minCpuLimit), 'more_than_or_equal');
    }
  }),
  minReplicasLimit: Yup.number().required('empty'),
  maxReplicasLimit: Yup.number().required('empty'),
  currency: Yup.string().required('empty').length(3, 'length'),
});
